import { queryClient } from './query-client';

export const clearupCache = () => {
  queryClient.clear();
};
